import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft, Search, HelpCircle, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";
import hexatechLogo from "@/assets/hexatech-logo.webp";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SEO
        title="Página Não Encontrada (404)"
        description="A página que procura não existe ou foi movida."
        url={location.pathname}
        noIndex
      />
    <div className="flex min-h-dvh flex-col items-center justify-center bg-gradient-to-b from-background to-muted/50 px-4">
      {/* Logo */}
      <Link to="/" className="mb-8">
        <img 
          src={hexatechLogo} 
          alt="HEXATECH" 
          className="h-12 w-auto opacity-80 hover:opacity-100 transition-opacity"
        />
      </Link>

      {/* 404 Display */}
      <div className="relative mb-6">
        <h1 className="text-[10rem] font-bold leading-none text-primary/10 select-none md:text-[14rem]">
          404
        </h1>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <Search className="mx-auto h-16 w-16 text-primary/60 mb-2" />
          </div>
        </div>
      </div>

      {/* Message */}
      <div className="max-w-md text-center mb-8">
        <h2 className="text-2xl font-semibold text-foreground mb-3">
          Página Não Encontrada
        </h2>
        <p className="text-muted-foreground leading-relaxed">
          Lamentamos, mas a página que procura não existe ou foi movida. 
          Verifique o endereço ou navegue para uma das opções abaixo.
        </p>
        <p className="text-sm text-muted-foreground/70 mt-2">
          Caminho solicitado: <code className="bg-muted px-2 py-0.5 rounded text-xs">{location.pathname}</code>
        </p>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-3 mb-12">
        <Button asChild size="lg" variant="default" className="gap-2">
          <Link to="/auth">
            <LogIn className="h-4 w-4" />
            Entrar na Conta
          </Link>
        </Button>
        <Button asChild size="lg" className="gap-2">
          <Link to="/">
            <Home className="h-4 w-4" />
            Ir para Início
          </Link>
        </Button>
        <Button asChild variant="ghost" size="lg" className="gap-2">
          <Link to="/equipamentos">
            <ArrowLeft className="h-4 w-4" />
            Ver Equipamentos
          </Link>
        </Button>
        <Button asChild variant="ghost" size="lg" className="gap-2">
          <Link to="/contacto">
            <HelpCircle className="h-4 w-4" />
            Contactar Suporte
          </Link>
        </Button>
      </div>

      {/* Quick Links */}
      <div className="text-center">
        <p className="text-sm text-muted-foreground mb-3">Links Rápidos</p>
        <div className="flex flex-wrap justify-center gap-4 text-sm">
          <Link to="/consumiveis" className="text-primary hover:underline">
            Consumíveis
          </Link>
          <span className="text-muted-foreground/30">•</span>
          <Link to="/solucoes" className="text-primary hover:underline">
            Soluções
          </Link>
          <span className="text-muted-foreground/30">•</span>
          <Link to="/assistencia" className="text-primary hover:underline">
            Suporte Técnico
          </Link>
          <span className="text-muted-foreground/30">•</span>
          <Link to="/sobre" className="text-primary hover:underline">
            Sobre Nós
          </Link>
        </div>
      </div>
    </div>
    </>
  );
};

export default NotFound;
